<template>
  <div>
    <el-card>
      <div class="flex-wrap">
        <el-date-picker
          v-model="Time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="m-r"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="onChangeTime"
        >
        </el-date-picker>
        <el-input
          v-model="Name"
          placeholder="请输入"
          class="m-r"
          style="width: 150px"
        ></el-input>
        <el-input
          v-model="IPAddress"
          placeholder="请输入IP地址"
          class="m-r"
          style="width: 150px"
        ></el-input>
        <el-input
          v-model="UserName"
          placeholder="请输入用户名"
          class="m-r"
          style="width: 150px"
        ></el-input>
        <el-input
          v-model="Description"
          placeholder="请输入描述"
          class="m-r"
          style="width: 150px"
        ></el-input>
        <el-select v-model="Action" placeholder="请选择行为" class="m-r">
          <el-option
            v-for="item in ActionList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Name"
          >
          </el-option>
        </el-select>
        <el-button type="primary">查询</el-button>
        <el-button type="primary">重置</el-button>
      </div>
    </el-card>
    <el-table :data="tableData" style="width: 100%; margin: 20px" border>
      <el-table-column label="序号" type="index" :index="indexAdd" width="50" />
      <el-table-column prop="UserName" label="用户名"> </el-table-column>
      <el-table-column prop="Action" label="行为"> </el-table-column>
      <el-table-column prop="Description" label="描述"> </el-table-column>
      <!-- <el-table-column prop="IPAddress" label="IP地址"> </el-table-column> -->
      <el-table-column prop="CreateTime" label="时间"> </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center; padding: 20px"
    >
    </el-pagination>
  </div>
</template>
<script>
import { GetLogInfo, GetActionInfo } from "../../api/api";
export default {
  data() {
    return {
      Time: [],
      IPAddress: "",
      UserName: "",
      Action: "",
      ActionList: [],
      Description: "",
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      Name: "",
      tableData: [],
    };
  },
  async created() {
    await this.GetActionInfo();
    await this.getNowTime();
    await this.GetLogInfo();
  },
  methods: {
    indexAdd(index) {
      // console.log(index, 222222)
      const page = this.PageIndex; // 当前页码
      const pagesize = this.PageSize; // 每页条数
      return index + 1 + (page - 1) * pagesize;
    },
    onChangeTime(e) {
      console.log(e);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetLogInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetLogInfo();
    },
    async GetLogInfo() {
      let res = await GetLogInfo({
        StartTime: this.Time.length != 0 ? this.Time[0] : "",
        EndTime: this.Time.length != 0 ? this.Time[1] : "",
        IsNeedTime: this.Time.length != 0 ? 1 : 0,
        IPAddress: this.IPAddress,
        UserName: this.UserName,
        Action: this.Action,
        Description: this.Description,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    // 获取行为
    async GetActionInfo() {
      let res = await GetActionInfo();
      if (res.data.success) {
        this.ActionList = res.data.response;
      }
    },
    // 获取年初-年末、月初-月末、
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var day = now.getDate(); //得到天
      if (day < 10) {
        day = "0" + day;
      }
      month = month + 1;
      month = month.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}`;

      var date_from = `${year}-${month}-01 00:00`;
      var date_to = `${year}-${month}-28 00:00`;

      this.Time.push(date_from);
      this.Time.push(date_to);
    },
  },
};
</script>
<style lang="less" scoped>
.flex-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.m-r {
  margin-right: 10px;
}
</style>